import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'influencer-decline-modal',
  templateUrl: './influencer-decline-modal.component.html',
  styleUrls: ['./influencer-decline-modal.component.scss']
})
export class InfluencerDeclineModalComponent implements OnInit {
  @Output() closeModalEvent: EventEmitter<any> = new EventEmitter();
  @Output() declineEvent: EventEmitter<any> = new EventEmitter();
  @Output() openContactEvent: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  closeModal() {
    this.closeModalEvent.emit();
  }

  onDecline() {
    this.declineEvent.emit();
  }

  openContact() {
    this.openContactEvent.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/influencer-decline-modal/influencer-decline-modal.component.ts